import { _axios } from "@/plugins/axios";
class CategoryService {
  async getCategoriasTramites() {
    return _axios.get("/categorias-tramites").then((response: any) => {
      return response.data;
    });
  }
  async getTramitesByCategory(category_id: number) {
    return _axios
      .get("/tramites-by-category?category_id=" + category_id)
      .then((response: any) => {
        return response.data;
      });
  }
  async getTramitesByLetter() {
    return _axios.get("/tramites-by-letter").then((response: any) => {
      return response.data;
    });
  }
  async getTramiteBySlug(slug: string) {
    return _axios.get("/tramite?slug=" + slug).then((response: any) => {
      return response.data;
    });
  }
  async getTramites() {
    return _axios.get("/tramites").then((response: any) => {
      return response.data;
    });
  }
  async searchTramitesByName(name: String, page: Number) {
    return _axios
      .get(
        `/search-tramites?name=${encodeURIComponent(String(name))}&page=${page}`
      )
      .then((response: any) => {
        return response.data;
      });
  }
}

export default new CategoryService();
